const FILTER_TYPE_LABELS = {
  date_start: "Début",
  date_end: "Fin",
  category: "Catégories",
  name: "Nom",
  author: "Auteur",
  wiki_page: "Page Wikifield",
};

const OP_LABELS = {
  contains: "Contient",
  not_contains: "Ne contient pas",
  empty: "Est vide",
  before: "Avant",
  after: "Après",
  on: "Le",
  is: "Est",
  is_not: "N'est pas",
};

function safeParseFilters(filters) {
  if (!filters) return null;
  if (typeof filters === "string") {
    try {
      return JSON.parse(filters);
    } catch {
      return null;
    }
  }
  return filters;
}

function summarizeRule(rule, categoryMap) {
  const type = FILTER_TYPE_LABELS[rule?.type] || rule?.type || "Règle";
  const op = OP_LABELS[rule?.op] || rule?.op || "";

  const hasValues = Array.isArray(rule?.values) && rule.values.length > 0;
  const hasValue = typeof rule?.value === "string" && rule.value.trim() !== "";

  if (hasValues) {
    const displayValues =
      rule?.type === "category"
        ? rule.values.map((v) => categoryMap[String(v)] || String(v))
        : rule.values;
    return `${type} ${op} ${displayValues.join(", ")}`;
  }

  if (hasValue) return `${type} ${op} ${rule.value}`;

  return [type, op].filter(Boolean).join(" ");
}

function summarizeNode(node, categoryMap, depth = 0) {
  if (!node) return "";

  // Group node
  if (node.operator && Array.isArray(node.conditions)) {
    const sep = node.operator === "OR" ? " Ou " : " Et ";
    const parts = node.conditions
      .map((c) => summarizeNode(c, categoryMap, depth + 1))
      .filter(Boolean);
    if (!parts.length) return "";

    let s = parts.join(sep);
    if (depth > 0) s = `(${s})`;
    return s;
  }

  // Leaf rule node
  if (node.type) return summarizeRule(node, categoryMap);

  return "";
}

export function summarizeTimelineFilters(filters, categoryMap = {}, maxLen = 160) {
  const root = safeParseFilters(filters);
  if (!root) return "";

  const result = summarizeNode(root, categoryMap, 0)
    .replace(/\s+/g, " ")
    .trim();

  if (!result) return "";
  if (result.length <= maxLen) return result;
  return result.slice(0, Math.max(0, maxLen - 1)).trimEnd() + "…";
}

